import styled from "styled-components";

export const ListItemContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;
